import styled from '@emotion/styled';
import { Button } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import { forwardRef } from 'react';

const ButtonStyle = styled(Button)(() => ({
  fontWeight: 700,
  borderRadius: '30px',
  padding: '10px 30px',
  color: '#ffffff',
  background: 'linear-gradient(92.25deg, #9B5FDA -2.57%, #562C82 113.38%)',
  height: 'max-content',
  fontFamily: 'Rubik',
  fontStyle: 'normal',
  fontSize: '14px'
}));

const ButtonStyleLoad = styled(LoadingButton)(() => ({
  fontWeight: 700,
  borderRadius: '30px',
  padding: '10px 30px',
  color: '#ffffff',
  background: 'linear-gradient(92.25deg, #9B5FDA -2.57%, #562C82 113.38%)',
  height: 'max-content',
  fontFamily: 'Rubik',
  fontStyle: 'normal',
  fontSize: '14px'
}));

export const ButtonPrimary = forwardRef(({ children, pending, ...rest }: any, ref) =>
  pending != undefined ? (
    <ButtonStyle variant="text" ref={ref} {...rest}>
      {children}
    </ButtonStyle>
  ) : (
    <ButtonStyleLoad variant="text" pending={pending} ref={ref} {...rest}>
      {children}
    </ButtonStyleLoad>
  )
);
